var _style, _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#A2001D;}\n\t.st2{fill:#496E2D;}\n\t.st3{fill:#000000;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0C145.9,0,52.1,69.5,15.9,167h480.2C459.9,69.5,366.1,0,256,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256,512c110.1,0,203.9-69.5,240.1-167H15.9C52.1,442.5,145.9,512,256,512z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M194.8,239.3c-0.1,0-0.3,0-0.4,0v0h-48.9c2.5-9.6,11.2-16.7,21.5-16.7v-33.4c-30.7,0-55.7,25-55.7,55.7v27.3 v0.6h83.1h0.4c3.1,0,5.6,2.5,5.6,5.6v11.1H89v33.4h144.7v-44.5C233.7,256.8,216.3,239.3,194.8,239.3L194.8,239.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.3,289.4V189.2h-33.4v133.6h55.7v-33.4L278.3,289.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M389.6,289.4V189.2h-33.4v100.2H345V256h-33.4v66.8h100.2v-33.4H389.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIq);
export default __webpack_public_path__ + "static/media/iq.097569e80f1ee79808cbaa087479ab30.svg";
export { ForwardRef as ReactComponent };